import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ButtonModule } from "@jack-sparrow-libraries/ui-kit";
import { RouterModule } from "@angular/router";
import { DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { NavigationService } from "@services/navigation.service";
import { AgatheYouCareService } from "@services/agathe-you-care.service";
import { AgatheYouCareAssets } from "@core/constantes/agathe-you-care.constant";

@Component({
	selector: "cba-not-found",
	templateUrl: "./not-found.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, ButtonModule, RouterModule],
})
export class NotFoundComponent {
	private readonly navigationService = inject(NavigationService);
	private readonly agatheYouCareService = inject(AgatheYouCareService);

	protected readonly $isCare = this.agatheYouCareService.$isCare;
	protected readonly AgatheYouCareAssets = AgatheYouCareAssets;

	goToDashboard() {
		this.navigationService.navigateByBase(NavigationBase.DOJO, DojoRoutesEnum.DASHBOARD);
	}
}
